import LatestBlogPostsCard from 'components/LatestBlogPostsCard';
import MostPopularTags from 'components/MostPopularTags';
import BlogCategoryListCard from 'components/BlogCategoryListCard';
import { SPostSidebarItem, SPostSidebar } from './styles';
import React from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';

function BlogPageSidebar({
  isPodcast = false,
  latestBlogposts = [],
  latestPodcasts = [],
}) {
  return (
    <Container>
      <SPostSidebar>
        {!isPodcast && (
          <SPostSidebarItem md={12}>
            <BlogCategoryListCard />
          </SPostSidebarItem>
        )}
        <SPostSidebarItem md={12}>
          <LatestBlogPostsCard posts={latestPodcasts} isPodcasts={true} />
        </SPostSidebarItem>

        <SPostSidebarItem md={12}>
          <LatestBlogPostsCard posts={latestBlogposts} />
        </SPostSidebarItem>

        {!isPodcast && (
          <SPostSidebarItem md={12}>
            <MostPopularTags size={100} />
          </SPostSidebarItem>
        )}
      </SPostSidebar>
    </Container>
  );
}

BlogPageSidebar.propTypes = {
  isPodcast: PropTypes.bool,
  categoryId: PropTypes.string,
  latestPodcasts: PropTypes.array,
  latestBlogposts: PropTypes.array,
};

export default BlogPageSidebar;
